import { IDeliveryStatusCount } from "../Interfaces/IDeliveryStatusCount.interface";

export const DeliveryStatusCount: IDeliveryStatusCount = {
    allCount: 0,
    onRoadCount: 0,
    goBackCount: 0,
    freeCount: 0
};
